import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/CN',
      name: 'CN',
      component: resolve => require(['@/components/CN'], resolve),
      meta: {
        title: '隐私政策'
      }
    },
    {
      path: '/EN',
      name: 'EN',
      component: resolve => require(['@/components/EN'], resolve),
      meta: {
        title: 'Privacy Policy'
      }
    },
    {
      path: '*',
      redirect: '/CN',
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js